import React from 'react';
import { motion } from 'framer-motion';
import { Check, Sparkles, ShieldCheck, Zap, CreditCard } from 'lucide-react';
import { trackInitiateCheckout } from '../utils/metaPixel';
export function PricingCards() {
  return <section id="pricing" className="py-20 px-4 scroll-mt-28 relative overflow-hidden" data-id="element-190">
      {/* Ambient glow */}
      <div className="absolute top-1/3 right-0 w-[400px] h-[400px] bg-gold/10 rounded-full blur-[130px] pointer-events-none" data-id="element-191" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-192">
        <div className="text-center mb-4" data-id="element-193">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-gold/10 border border-gold/30 text-gold-light text-xs font-semibold tracking-widest uppercase" data-id="element-194">
            <Sparkles className="w-3.5 h-3.5" data-id="element-195" /> Oferta Especial
          </span>
        </div>
        <div className="text-center mb-12" data-id="element-196">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-3" data-id="element-197">
            Hoy recibes
          </h2>
        </div>

        <div className="flex justify-center" data-id="element-198">
          <motion.div id="oferta-premium" initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} whileHover={{
          y: -6
        }} className="relative bg-dark-card rounded-2xl p-8 flex flex-col shadow-[0_0_50px_rgba(212,168,67,0.2)] max-w-md w-full" data-id="element-199">
            {/* Animated gold border */}
            <div className="absolute inset-0 rounded-2xl border-2 border-gold pointer-events-none" data-id="element-200" />
            <div className="absolute inset-0 rounded-2xl bg-gradient-to-b from-gold/[0.06] to-transparent pointer-events-none" data-id="element-201" />

            <div className="relative z-10 flex flex-col h-full" data-id="element-202">
              <div className="mb-6 mt-2 text-center" data-id="element-203">
                <div className="flex items-center justify-center gap-2 mb-3" data-id="element-204">
                  <span className="text-2xl" data-id="element-205">⚔️</span>
                  <h3 className="text-2xl font-heading font-bold text-white" data-id="element-206">
                    Colección Vikingos Legendarios
                  </h3>
                </div>

                <div className="bg-dark/50 rounded-lg p-4 mb-6 border border-dark-border/50" data-id="element-207">
                  <div className="flex justify-between items-center mb-2 text-sm" data-id="element-208">
                    <span className="text-gray-300" data-id="element-209">6 Tomos Digitales</span>
                    <span className="text-gray-400 line-through" data-id="element-210">
                      $59.990 ARS
                    </span>
                  </div>
                  <div className="flex justify-between items-center mb-3 text-sm" data-id="element-211">
                    <span className="text-gray-300" data-id="element-212">3 Bonos Exclusivos</span>
                    <span className="text-gray-400 line-through" data-id="element-213">
                      $39.990 ARS
                    </span>
                  </div>
                  <div className="flex justify-between items-center pt-3 border-t border-dark-border/50" data-id="element-214">
                    <span className="font-bold text-white" data-id="element-215">VALOR TOTAL</span>
                    <span className="text-red-400 font-bold line-through" data-id="element-216">
                      $99.980 ARS
                    </span>
                  </div>
                </div>

                <p className="text-gold-light font-medium mb-2" data-id="element-217">
                  Hoy puede ser tuyo por solo...
                </p>
                <div className="flex items-baseline justify-center gap-1.5" data-id="element-218">
                  <span className="text-5xl font-heading font-bold text-gold-light" data-id="element-219">
                    $19.990
                  </span>
                  <span className="text-sm text-gray-400" data-id="element-220">ARS</span>
                </div>
              </div>

              <ul className="space-y-4 mb-8 text-base flex-grow" data-id="element-221">
                <li className="flex items-start gap-3 text-white font-medium" data-id="element-222">
                  <Check className="w-5 h-5 text-gold shrink-0 mt-0.5" data-id="element-223" />
                  <span data-id="element-224">6 tomos completos</span>
                </li>
                <li className="flex items-start gap-3 text-white font-medium" data-id="element-225">
                  <Check className="w-5 h-5 text-gold shrink-0 mt-0.5" data-id="element-226" />
                  <span data-id="element-227">3 bonos exclusivos</span>
                </li>
                <li className="flex items-start gap-3 text-white font-medium" data-id="element-228">
                  <Check className="w-5 h-5 text-gold shrink-0 mt-0.5" data-id="element-229" />
                  <span data-id="element-230">100% Digital</span>
                </li>
                <li className="flex items-start gap-3 text-white font-medium" data-id="element-231">
                  <Check className="w-5 h-5 text-gold shrink-0 mt-0.5" data-id="element-232" />
                  <span data-id="element-233">Acceso inmediato</span>
                </li>
                <li className="flex items-start gap-3 text-white font-medium" data-id="element-234">
                  <Check className="w-5 h-5 text-gold shrink-0 mt-0.5" data-id="element-235" />
                  <span data-id="element-236">Acceso de por vida</span>
                </li>
              </ul>

              <div className="mt-auto" data-id="element-237">
                <motion.a href="#checkout" target="_blank" rel="noopener noreferrer" onClick={() => trackInitiateCheckout('Colección Vikingos Legendarios', 19990)} whileHover={{
                scale: 1.02
              }} whileTap={{
                scale: 0.98
              }} className="block w-full py-4 text-center bg-gradient-to-r from-gold to-gold-light text-dark font-bold text-lg rounded-xl shadow-[0_0_25px_rgba(212,168,67,0.35)] hover:shadow-[0_0_40px_rgba(212,168,67,0.55)] transition-all animate-pulse-slow" data-id="element-238">
                  👉 QUIERO ACCEDER AHORA
                </motion.a>
                <p className="text-center text-xs text-gray-400 mt-4 flex items-center justify-center gap-2" data-id="element-239">
                  <ShieldCheck className="w-4 h-4 text-gold" data-id="element-240" /> Pago seguro ·
                  Acceso inmediato
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}